import { render } from "./SubcategoriesView.vue?vue&type=template&id=cc8a6532"
import script from "./SubcategoriesView.vue?vue&type=script&lang=js"
export * from "./SubcategoriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__